import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./Constants";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const PrepareQuestionList = () => {
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `${BASE_URL}prepare_question_type_list`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.status) {
        setQuestions(data.data);
        setFilteredQuestions(data.data);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Filter Logic (Department + Question Search)
  useEffect(() => {
    let filtered = questions;

    // Dropdown Filter
    if (selectedDept) {
      filtered = filtered.filter(
        (item) => item.dept === selectedDept
      );
    }

    // Search (Department OR Question)
    if (searchText) {
      filtered = filtered.filter(
        (item) =>
          item.dept.toLowerCase().includes(searchText.toLowerCase()) ||
          item.question.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    setFilteredQuestions(filtered);
  }, [selectedDept, searchText, questions]);

  const uniqueDepartments = [
    ...new Set(questions.map((item) => item.dept)),
  ];

  if (loading) {
    return (
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper text-center">
              <div className="spinner-border text-primary mt-5" />
              <p className="mt-3">Loading Question Types...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-4">
                Question Type Management
              </h4>

              <button
                className="btn btn-success px-4"
                onClick={() => navigate("/AddQuestionType")}
              >
                + Add Question Type
              </button>
            </div>

            {/* Filter Section */}
            <div className="card shadow-sm mb-4 border-0">
              <div className="card-body">
                <div className="row">

  {/* Department Filter */}
  <div className="col-md-4 mb-3">
    <div className="d-flex align-items-center">
      <label className="form-label fw-semibold me-2 mb-0" style={{ minWidth: "140px" }}>
        Department
      </label>
      <select
        className="form-control input-font"
        style={{ padding: "0px 10px" }}
        value={selectedDept}
        onChange={(e) => setSelectedDept(e.target.value)}
      >
        <option value="">All Departments</option>
        {uniqueDepartments.map((dept, index) => (
          <option key={index} value={dept}>
            {dept}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* Search Box */}
  <div className="col-md-4 mb-3">
    <div className="d-flex align-items-center">
      <label className="form-label fw-semibold me-2 mb-0" style={{ minWidth: "80px" }}>
        Search
      </label>
      <input
        type="text"
        placeholder="Search..."
        className="form-control input-font"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>
  </div>

  {/* Reset Button */}
  <div className="col-md-4 mb-3">
    <div className="d-flex align-items-center">
      <label className="form-label fw-semibold me-2 mb-0" style={{ minWidth: "80px" }}>
        Action
      </label>
      <button
        className="btn btn-outline-secondary w-100 input-font"
        onClick={() => {
          setSelectedDept("");
          setSearchText("");
        }}
      >
        Reset
      </button>
    </div>
  </div>

</div>

              </div>
            </div>

            {/* Table Section */}
            <div className="card shadow-sm border-0">
              <div className="card-body">

                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th>ID</th>
                        <th>Department</th>
                        <th>Question</th>
                        <th>Limit</th>
                        <th>Created By</th>
                        <th>Created On</th>
                        <th>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredQuestions.length > 0 ? (
                        filteredQuestions.map((item) => (
                          <tr key={item.id}>
                            <td className="fw-semibold">
                              {item.id}
                            </td>

                            <td>{item.dept}</td>

                            <td style={{ maxWidth: "350px" }}>
                              {item.question_type}
                            </td>

                            <td>{item.question_limit}</td>

                            <td>{item.created_by}</td>

                            <td>
                              {new Date(
                                item.created_on
                              ).toLocaleString()}
                            </td>

                            <td>
                              <span
                                className={`badge ${
                                  item.status === "A"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {item.status === "A"
                                  ? "Active"
                                  : "Inactive"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center py-4"
                          >
                            <span className="text-muted">
                              No Data Found
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

          </div>

          {/* Footer */}
          <footer className="footer mt-4">
            <span className="text-muted">
              © {new Date().getFullYear()} Vijaya Diagnostic Centre
            </span>
          </footer>

        </div>
      </div>
    </div>
  );
};

export default PrepareQuestionList;
